/**
 * Farklı tarih formatlarını sayısal değere dönüştüren yardımcı fonksiyon
 * Bu fonksiyon, hem CustomDate hem de JavaScript Date objelerini destekler
 * @param {Object|Date} date - Dönüştürülecek tarih objesi
 * @returns {number} - Tarih için sayısal değer (sıralama için)
 */
export const getDateNumericValue = (date) => {
    try {
        if (!date) return Number.MIN_SAFE_INTEGER;
        
        let year = 0, month = 0, day = 0;
        
        // CustomDate sınıfı için
        if (typeof date.getFullYear === 'function') {
            // CustomDate sınıfı getFullYear metodunu kullanır
            year = date.getFullYear();
            month = typeof date.getMonth === 'function' ? date.getMonth() : 0;
            day = typeof date.getDate === 'function' ? date.getDate() : 1;
        } 
        // CustomDate içindeki date nesnesi
        else if (date.date && typeof date.date.getFullYear === 'function') {
            year = date.date.getFullYear();
            month = date.date.getMonth();
            day = date.date.getDate();
        } 
        // Doğrudan özellikler (year, month, day)
        else if (date.year !== undefined) {
            year = date.year;
            month = date.month !== undefined ? date.month : 0;
            day = date.day !== undefined ? date.day : 1;
        } 
        // JavaScript Date objesi
        else if (date instanceof Date) {
            year = date.getFullYear();
            month = date.getMonth();
            day = date.getDate();
        }
        
        // Sayısal değer oluştur: YYYYMMDD formatında
        // Negatif yıllar (MÖ) için özel işlem
        if (year < 0) {
            // MÖ tarihler için negatif değer döndür, böylece doğru sıralanır
            return year * 10000 - (month * 100 + day);
        }
        
        return year * 10000 + month * 100 + day;
    } catch (error) {
        console.error('Tarih değeri dönüştürme hatası:', error, date);
        return Number.MIN_SAFE_INTEGER;
    }
};

export default getDateNumericValue; 